<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Household Review Component"
    seFeDataSubtitle="Display Household Changes in multi-step household flows"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header
        seFeDataTitle="When to use"
      ></se-fe-card-header>
      <se-fe-card-content>
        <p>Use in Persona Picker and Profile Module</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example:"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-household-review-example></se-po-household-review-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
